<template>
<div class="content-wrap">
    <div class="col-md-6 col-lg-6 cdiv-tile-outer" v-for="(el,kye) in cosmicMenuItems.subset" :key=kye>    
        <div v-bind:class = "(((kye+1)%4)==0)?'blog-entry animate-box ':'blog-entry animate-box '" @mouseover="mousein(kye)" @mouseleave="mouseout(kye)">
            

            <div class="blog-img" :style="(el['image'])?'background-image: url('+CONTENT_DOMAIN+'/img/helpwhereyouare_site/ThemeCosmic/'+el['image']+');':'background-image: url('+CONTENT_DOMAIN+'/img/helpwhereyouare_site/ThemeCosmic/dummy_div.png);'">
            <!-- <div class="blog-img home-tile-bg" :style="'background-image: url('+LOCAL_HOST+'/ThemeCosmic/images/division_275x300.png);'"> -->
                <div class="desc cosmic-desc" tabindex="0" @focus="mousein(kye)" >
                    <!-- <p class="tag"></p> -->
                    <a @focus.native="mousein(kye)" v-if="(el['url_external'] === 1)" class="abtn-style" href="#" v-html="languageData[el.name]" target="_blank" v-on:click.stop.prevent="openNewWindow(el['url'])"></a>
                    <router-link v-if="(el['url_external'] === 0)" class="abtn-style" @focus.native="mousein(kye)" :to="el['url']" v-html="languageData[el['name']]"></router-link>

                    <!--  <h2 class="head-article home-tile-head" v-html="el['heading']"></h2> -->
                    <transition name="slide-fade">  
                       <!--  <p v-html="el['content']" > </p> -->
                    </transition>
                    <!-- <a @focus.native="mousein(kye)" v-if="(el['filename'] === 'external')" class="btn-style" :href="el['href']" v-html="el['hrefname']" target="_blank"></a>
                    <router-link v-if="(el['filename'] === 'internal')" class="btn-style" @focus.native="mousein(kye)" :to="el['href']" v-html="el['hrefname']"></router-link> -->
                </div>
            </div>
        </div>
    </div>
    
    
</div>
</template>

<script>
  import axios from 'axios';
  export default {
    name: 'CosmicDivisionTiles',
	data() {
        return {          
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN,
            menuParent:this.$route.params.cdivision_id,
            LOCAL_HOST:this.$store.state.LOCAL_HOST,
            newShow:''
        }
    },    
    components: {

     },
    watch: { 
        // call again the method if the route changes
        '$route': 'showContent'        
        
    },
    computed:{  
        cosmicMenuItems(){
            return this.$store.state.cosmicMenu['i'+this.menuParent]
        },
        languageData() {
            var titleValue =this.decodeHtmlLang(this.$store.state.languageData[this.$store.state.cosmicMenu['i'+this.menuParent]['name']]);              
            var home = this.decodeHtmlLang(this.$store.state.languageData['d00'])
            document.title = titleValue+' | '+this.$store.state.companyData['name_company'];

            return this.$store.state.languageData;
        }  
        // subMenus(){return this.menuItems[this.menuParent]}
    },
    mounted :function(){     
       this.showContent();
	},
	methods:{
        showContent(){          
            
            this.web_hits();
            this.showFocus();
            
            //location.reload();
            
        },
        showFocus(){                                        
            var heading = document.querySelector('h1');
            heading.focus();
        },
        mousein(kye){           
            this.newShow=kye
        },
        mouseout(kye){             
            this.newShow=''
        },
         openNewWindow:function(link){                
            window.open(link,'menu', 'location');                
        },

    }
  }
</script>

<style scoped>
.blog-entry-travel .desc {
    width: 0%;
    padding: 5em 0em 6em 0em;
    margin: 0;
    background: #fafafa;
    
}
article .desc .meta span {
   
    margin-bottom: 0 !important;
}
article {
    width: 334px;
    float: left;
    margin-bottom: 2em;
    /* float: left; */
    margin-right: 2em;
}
.blog-entry-travel .blog-img {
    width: inherit !important;
}

.blog-entry-travel .desc .meta {    
    top: 0px;
    width: 334px;
    background: #1f1f1fa8;
    right: 0;
    min-width: 165px;
}
.blog-entry-travel .desc .meta:hover, .blog-entry-travel .desc .meta:focus{
    background: #2f2f2fcc;
}
article .desc .meta {
    left: auto;
    text-align: center;
}
.blog-entry-travel .desc .meta span a {
    color: #ffffffeb;
}
.blog-entry-travel .desc .meta span a:hover {
    color: #ffffff;
}



.blog-entry .blog-img{
    height: 300px !important;
}


@media screen and (max-width: 768px){
    .blog-entry-travel .desc .meta {
        top: 0px !important;
        position: absolute !important;
        text-align: right;
    }
    article .desc .meta{
        text-align: center !important;
    }
    article {
        width: 320px;
        margin-right: 10px;
    }
    .blog-entry-travel .desc .meta{
        width: 320px;
    }
   
}
@media screen and (max-width: 480px){
    article {
        width: 95%;
    }
    .blog-entry-travel .desc .meta{
        width: 95%;
    }
}

.content-wrap {
    padding-right: 0;
    margin-top: 40px;
}
.blog-entry .desc {
    background: #2f2f2fcc !important;/*25252573 */    
    width: 100%;
}
.btn-style{
    display: inline-block;
    bordeR: 1px solid rgba(255, 255, 255, 0.5);
    padding: 3px 11px;
    -webkit-border-radius: 16px;
    -moz-border-radius: 16px;
    -ms-border-radius: 16px;
    border-radius: 16px;
    color: #fcfcfc;
    background: #505050ed;
    font-size: 12px;
}
.btn-style:hover{
    border: 1px solid rgba(255, 255, 255, 0.82);
    color: #fff;
}
.head-article{
    color: #fff !important;
}
.blog-entry .blog-img .desc p {
    color: hsl(0deg 0% 93%) !important;
}
.abtn-style{
    /* display: inline-block; */
    letter-spacing: 0.55px;
    color: #fcfcfc;
    /* font-weight: bold; */
    font-size: 24px;
    line-height: 35px;
    display: table-cell;
    vertical-align: middle;
}
.abtn-style:hover{
    color: #fff;
}
.cosmic-desc{
    padding: 12px 25px 18px 25px !important;
    min-height: 135px;
    display: inline-table;
}
.cosmic-desc p{
    font-size: 16px;
    letter-spacing: .30px;
}
.left-pad{
    padding-left: 7px;
}
.right-pad{
    padding-right: 7px;
}
.home-tile-bg{
    height: 300px !important;
}



.cdiv-tile-outer{
    padding:0;
    width:318px;
    padding:0 21px;
    float: left;
}
@media only screen and (max-width: 575px) {
    .home-tile-bg{
        height: 300px !important;
    }
    .left-pad{
        padding-left: 15px;
        padding-right: 15px;
    }
    .right-pad{
        padding-right: 15px;
        padding-left: 15px;
    }
    .abtn-style{
        font-size: 20px;    
    }
    .cosmic-desc p{
        font-size: 14px;
    }
    .cosmic-desc {
        padding: 12px 25px 20px 35px !important;
    }
    .cdiv-tile-outer{
        float: left !important;
    }
}
@media  (min-width: 768px) and (max-width: 1000px) {
    .home-tile-bg{
        height: 300px !important;
    }
    .abtn-style{
        font-size: 20px;    
    }
    .cosmic-desc p{
        font-size: 14px;
    }
    .cdiv-tile-outer{
        float: left !important;
    }   

}


</style>
